import { useMutation } from "@tanstack/react-query";

import { broadcastAPI } from "@api/broadcast";
import { processRequest } from "@api/config";

import { API_PREFIXES } from "@configs/api";

export const useStartAwayModeMutation = () =>
	useMutation({
		mutationFn: async () => {
			await processRequest({
				prefix: API_PREFIXES.START_AWAY_MODE,
				request: (token) => broadcastAPI.startAwayModeAsync({ token }),
			});
		},
		onError: (error) => {
			console.error("Error during start away mode:", error);
		},
		onSuccess: () => {},
	});

export const useStopAwayModeMutation = () =>
	useMutation({
		mutationFn: async () => {
			await processRequest({
				prefix: API_PREFIXES.STOP_AWAY_MODE,
				request: (token) => broadcastAPI.stopAwayModeAsync({ token }),
			});
		},
	});
